<div class="td-cnt-ext">
    <div class="td-cnt" [ngClass]="{'td-cnt-mobile' : isMobile}">
        <div class="td-cnt-title">
            <i class="fas fa-calendar dialog-icon"></i>
            <span class="te-title">{{'grid.DeliveryDate' | translate}}</span>
        </div>
        <div class="td-cnt-body flex-col">
            <div class="cnt-info">
                <!-- if deliverySource is not Itdcr -->
                <ng-container *ngIf="!isItdcrSource">
                    <ng-container *ngIf="item!['deliveryStatus'] != 'Validated'">
                        <span class="bold">{{'commons.description' | translate}}</span>
                        <span class="span-description"
                            *ngIf="!item?.deliverySourceDescription">{{'enquiryBook.deliveryToBeEvaluated' |
                            translate}}</span>
                        <span class="span-description" [innerHTML]="item?.deliverySourceDescription || ''">
                        </span>
                    </ng-container>
                    <div class="deliveryDates-container">
                        <div *ngFor="let deliveryDate of deliveryDatesCollection; let i = index" class="item">
                            <div>
                                <teiasoft-input [type]="'string'" [labelText]="'grid.BaseDeliveryDate' | translate"
                                    [isMobile]="isMobile"
                                    [value]=" deliveryDate.deliveryNumberOfWeeks ? formatWeeks(deliveryDate.deliveryNumberOfWeeks!) : '-'"
                                    [hideLabel]="i > 0" [isValid]="true" [readOnly]="true">
                                </teiasoft-input>
                            </div>
                            <div>
                                <teiasoft-input [type]="'string'" [labelText]="'grid.ExtraLeadTime' | translate"
                                    [isMobile]="isMobile" [value]="formatWeeks(item?.extraLeadTime!)" [isValid]="true"
                                    [hideLabel]="i > 0" [readOnly]="true">
                                </teiasoft-input>
                            </div>
                            <div>
                                <teiasoft-input [type]="'string'" [labelText]="'grid.DeliveryDate' | translate"
                                    [isMobile]="isMobile"
                                    [value]="formatWeeks(deliveryDate.deliveryNumberOfWeeksWithExtraLeadTime!)"
                                    [hideLabel]="i > 0" [isValid]="true" [readOnly]="true">
                                </teiasoft-input>
                            </div>
                            <!-- Quantity -->
                            <div>
                                <teiasoft-input [type]="'number'" [labelText]="'grid.Quantity' | translate"
                                    [isMobile]="isMobile" [value]="deliveryDate.deliveryQuantity" [isValid]="true"
                                    [hideLabel]="i > 0" [readOnly]="true"></teiasoft-input>
                            </div>
                            <!-- UOM -->
                            <div>
                                <teiasoft-input [type]="'string'" [labelText]="'grid.QuantityUom' | translate"
                                    [isMobile]="isMobile" [value]="deliveryDate.deliveryQuantityUom" [isValid]="true"
                                    [hideLabel]="i > 0" [readOnly]="true"></teiasoft-input>
                            </div>
                        </div>
                    </div>
                    <span class="span-description" *ngIf="item!['deliveryStatus'] == 'Validated'"
                        [innerHTML]="item?.deliverySourceDescription || ''">
                    </span>
                    <div *ngIf="showItdcrHistoryLink" class="modal-link-bottom-right">
                        <div class="cnt-link">
                            <i class="fas fa-caret-right ico-link"></i>
                            <teiasoft-link [text]="'enquiryBook.viewITDCR' | translate"
                                (onClick)="onNavigateToItdcrHistory()"></teiasoft-link>
                        </div>
                    </div>
                </ng-container>
                <!-- if deliverySource is Itdcr -->
                <ng-container *ngIf="isItdcrSource">
                    <div style="overflow: auto;">
                        <div class="deliveryDates-container itdcr-container">
                            <div *ngFor="let deliveryDate of deliveryDatesCollection; let i = index"
                                class="item itdcr-item">
                                <div class="week-picker">
                                    <teiasoft-week-picker [labelText]="'grid.BaseDeliveryDate' | translate"
                                        [value]="deliveryDate.deliveryWeekOfYear" [isMobile]="isMobile"
                                        [hideLabel]="i > 0" [minDate]="minDate" [readOnly]="readOnly"
                                        (onChange)="onDeliveryWeekChange($event, i)">
                                    </teiasoft-week-picker>
                                </div>
                                <div>
                                    <teiasoft-input [type]="'string'" [labelText]="'grid.ExtraLeadTime' | translate"
                                        [isMobile]="isMobile" [value]="formatWeeks(item?.extraLeadTime!)"
                                        [isValid]="true" [hideLabel]="i > 0" [readOnly]="true">
                                    </teiasoft-input>
                                </div>
                                <div class="week-picker">
                                    <teiasoft-input [type]="'string'" [labelText]="'grid.DeliveryWeek' | translate"
                                        [value]="deliveryDate.deliveryWeekOfYearWithExtraLeadTime" [isMobile]="isMobile"
                                        [hideLabel]="i > 0" [readOnly]="true">
                                    </teiasoft-input>
                                </div>
                                <div>
                                    <teiasoft-input [type]="'number'" [labelText]="'grid.Quantity' | translate"
                                        [isMobile]="isMobile" [value]="deliveryDate.deliveryQuantity" [isValid]="true"
                                        [hideLabel]="i > 0" [readOnly]="readOnly"
                                        (onInput)="onDeliveryQuantityChange($event, i)">
                                    </teiasoft-input>
                                </div>
                                <div>
                                    <teiasoft-input [type]="'string'" [labelText]="'grid.QuantityUom' | translate"
                                        [isMobile]="isMobile"
                                        [value]="deliveryDate.deliveryQuantityUom || item?.quantityUom" [isValid]="true"
                                        [hideLabel]="i > 0" [readOnly]="true">
                                    </teiasoft-input>
                                </div>
                                <button *ngIf="!readOnly && deliveryDatesCollection.length > 1" type="button"
                                    class="icon-btn" (click)="removeDeliveryDateRow(i)">
                                    <i class="fal fa-trash"></i>
                                </button>
                            </div>
                        </div>
                        <div class="delivery-actions" *ngIf="!readOnly">
                            <teiasoft-button [type]="'tb-secondary'" [text]="'commons.add' | translate"
                                [isMobile]="isMobile" [disabled]="false" [noWidth]="true"
                                (onClick)="addDeliveryDateRow()"></teiasoft-button>
                        </div>
                    </div>
                    <div>
                        <p class="mill-answer">{{'feasibility.millAnswer' | translate}}</p>
                        <span class="value" [innerHTML]="item?.deliverySourceDescription || ''"></span>

                    </div>
                    <div *ngIf="showItdcrHistoryLink" class="modal-link-bottom-right">
                        <div class="cnt-link">
                            <i class="fas fa-caret-right ico-link"></i>
                            <teiasoft-link [text]="'enquiryBook.viewITDCR' | translate"
                                (onClick)="onNavigateToItdcrHistory()"></teiasoft-link>
                        </div>
                    </div>
                </ng-container>

            </div>
        </div>

        <div class="td-cnt-btn" [ngClass]="{'td-cnt-btn-mobile' : isMobile}">
            <teiasoft-button (onClick)="onCancelClick()" class="mr-5" [type]="'tb-cancel'"
                [text]="'commons.cancel' | translate" [isMobile]="isMobile"></teiasoft-button>
            <ng-container *ngIf="isItdcrSource && !readOnly">
                <teiasoft-button class="mr-5" [type]="'tb-primary'" [text]="'commons.save' | translate"
                    [isMobile]="isMobile" [disabled]="!canSave()" [noWidth]="true" (onClick)="onSaveClick()">
                </teiasoft-button>
            </ng-container>
            <ng-container *ngIf="!readOnly">
                <teiasoft-button [type]="'tb-primary'" [text]="'costingTool.openITR' | translate" [isMobile]="isMobile"
                    [disabled]="false" [noWidth]="true" [fullWidth]="true"
                    (onClick)="onOpenITDCRClick()"></teiasoft-button>
            </ng-container>
        </div>
    </div>
</div>
<app-modal-view-itdcr *ngIf="showItdcrViewerModal" [itdcrNo]="selectedItdcrNo" [showHistory]="true"
    (onClose)="onCloseItdcrViewer()"></app-modal-view-itdcr>
